import { useEffect } from 'react'

import { storageDrawerOpen } from 'constants/storage'
import storage from 'modules/storage'
import { useAppDispatch, useAppSelector } from 'store'
import { setDrawerIsOpen } from 'store/ui/actions'
import { selectUIDrawer } from 'store/ui/selectors'

export const useSyncLayout = (): void => {
  const dispatch = useAppDispatch()

  const { isOpen: drawerIsOpen } = useAppSelector(selectUIDrawer)

  useEffect(() => {
    const drawerOpenFromStorage = storage.getItem<boolean>(storageDrawerOpen)
    if (drawerOpenFromStorage !== null && drawerOpenFromStorage !== drawerIsOpen) {
      dispatch(setDrawerIsOpen(drawerOpenFromStorage))
    }
  }, [])

  useEffect(() => {
    storage.setItem<boolean>(storageDrawerOpen, drawerIsOpen)
  }, [drawerIsOpen])
}
